import React from 'react';
import './blog-post.css';
import './blog-slides.css';

const WinterStudySesh = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Winter MM3 x MiT: Study Date</h2>
                    <p className="site-post-meta">March 11, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you for joining us for our last member meeting of the quarter! We hope you guys were able to get a lot of studying done with lots of snacks and drinks!
                    <br></br>
                    <br></br>
                    Congratulations to all of our winners! We hope everyone had an amazing time! Good luck with finals!
                    <br></br>
                    <br></br>
                    </p>

                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default WinterStudySesh;
